import React, { lazy } from 'react';
import { Box, Heading, Text, VStack, List, ListItem, ListIcon, Image } from '@chakra-ui/react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
interface ServiceSectionProps {
  imageUrl: string;
  title: string;
  description?: string;
  features?: string[];
  ctaText: string;
  ctaHref?: string;
  variant?: 'default' | 'highlighted';
}
export function ServiceSection({
  imageUrl,
  title,
  description,
  features,
  ctaText,
  ctaHref,
  variant = 'default'
}: ServiceSectionProps) {
  return <Box bg={variant === 'highlighted' ? 'rgba(220, 38, 38, 0.1)' : 'rgba(26, 26, 26, 0.8)'} borderWidth="2px" borderColor={variant === 'highlighted' ? 'brand.500' : 'gray.800'} borderRadius="lg" overflow="hidden" backdropFilter="blur(10px)" transition="all 0.3s ease" _hover={{
    borderColor: variant === 'highlighted' ? 'brand.400' : 'gray.700',
    transform: 'translateY(-4px)',
    boxShadow: variant === 'highlighted' ? '0 10px 40px rgba(220, 38, 38, 0.3)' : '0 10px 40px rgba(0, 0, 0, 0.5)'
  }} data-id="element-14" data-mp="3iujyb1evel7f">
      <Box position="relative" h="200px" overflow="hidden" data-id="element-15" data-mp="hzodu86gswgk">
        <Image src={imageUrl} alt={title} w="full" h="full" objectFit="cover" filter="brightness(0.4)" loading="lazy" data-id="element-16" data-mp="i2aju3dpj3wo" />
        <Box position="absolute" top={0} left={0} right={0} bottom={0} bgGradient={variant === 'highlighted' ? 'linear(to-b, transparent, rgba(220, 38, 38, 0.3))' : 'linear(to-b, transparent, rgba(26, 26, 26, 0.9))'} data-id="element-17" data-mp="rwax4sj57fgh" />
      </Box>

      <VStack spacing={6} align="stretch" p={{
      base: 6,
      md: 8
    }} data-id="element-18" data-mp="1apo9rhizmz7a">
        <Heading as="h3" size={{
        base: 'lg',
        md: 'xl'
      }} textAlign="center" color={variant === 'highlighted' ? 'brand.400' : 'fire.400'} textTransform="uppercase" letterSpacing="wider" fontWeight="black" textShadow={variant === 'highlighted' ? '0 0 20px rgba(220, 38, 38, 0.8), 0 0 40px rgba(220, 38, 38, 0.4)' : '0 0 15px rgba(245, 158, 11, 0.8), 0 0 30px rgba(245, 158, 11, 0.4)'} data-id="element-19" data-mp="1fny4xs4ppzsw">
          {title}
        </Heading>

        {description && <Text fontSize={{
        base: 'md',
        md: 'lg'
      }} color="gray.300" textAlign="center" lineHeight="tall" data-id="element-20" data-mp="1io841g1smzpx">
            {description}
          </Text>}

        {features && features.length > 0 && <List spacing={3} mt={4} data-id="element-21" data-mp="3fgi4alrp13ej">
            {features.map((feature, index) => <ListItem key={index} display="flex" alignItems="flex-start" data-id="element-22" data-mp="3fiusvhryic0k" data-mpi={index}>
                <ListIcon as={CheckIcon} color="fire.400" mt={1} boxSize={5} data-id="element-23" data-mp="1uz94rm1a5866" />
                <Text color="gray.200" fontSize={{
            base: 'sm',
            md: 'md'
          }} data-id="element-24" data-mp="1zw92n9nz74m7">
                  {feature}
                </Text>
              </ListItem>)}
          </List>}

        <CTAButton href={ctaHref} mt={4} w="full" data-id="element-25" data-mp="1c76i9u1yixo0">
          {ctaText}
        </CTAButton>
      </VStack>
    </Box>;
}